/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatconverterpresets2Inputs */

const en_formatconverterpresets2 = /** @type {(inputs: Formatconverterpresets2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formats`)
};

const de_formatconverterpresets2 = /** @type {(inputs: Formatconverterpresets2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formate`)
};

/**
* | output |
* | --- |
* | "Formats" |
*
* @param {Formatconverterpresets2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatconverterpresets2 = /** @type {((inputs?: Formatconverterpresets2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatconverterpresets2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatconverterpresets2(inputs)
	return de_formatconverterpresets2(inputs)
});
export { formatconverterpresets2 as "formatConverterPresets" }